import { render } from "./InstructionImageWindow.vue?vue&type=template&id=4416d426&scoped=true"
import script from "./InstructionImageWindow.vue?vue&type=script&lang=js"
export * from "./InstructionImageWindow.vue?vue&type=script&lang=js"

import "./InstructionImageWindow.vue?vue&type=style&index=0&id=4416d426&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4416d426"]])

export default __exports__